import type { TypedDocumentNode } from '@apollo/client';
import { gql } from '@apollo/client';
import { useState } from 'react';

import { useQueryLoader } from '@sorare/core/src/hooks/graphql/useQueryLoader';
import { queryLoader } from '@sorare/core/src/lib/navigation/queryLoader';

import { CommonPacks } from './CommonPacks';
import type {
  CommonPacksQuery,
  CommonPacksQueryVariables,
} from './__generated__/index.graphql';

const COMMON_PACKS_QUERY = gql`
  query CommonPacksQuery($sport: Sport!) {
    market {
      id
      ...CommonPacks_marketRoot
    }
    currentUser {
      slug
      anyUserSportProfile(sport: $sport) {
        id
        commonGameOnboarded
        availableOnboardingLeaderboards(rarity: common)
      }
    }
  }
  ${CommonPacks.fragments.marketRoot}
` as TypedDocumentNode<CommonPacksQuery, CommonPacksQueryVariables>;

export const loader = queryLoader(COMMON_PACKS_QUERY, ({ sport }) => ({
  sport,
}));

export const CommonPacksPage = () => {
  const { data, refetch } = useQueryLoader<CommonPacksQuery>();
  const { market, currentUser } = data;

  const [showClaimFirstPack, setShowClaimFirstPack] = useState(false);

  if (
    currentUser?.anyUserSportProfile?.commonGameOnboarded === false &&
    currentUser?.anyUserSportProfile?.availableOnboardingLeaderboards &&
    !showClaimFirstPack
  ) {
    setShowClaimFirstPack(true);
  }

  return (
    <CommonPacks
      showClaimFirstPack={showClaimFirstPack}
      marketRoot={market}
      refetch={refetch}
    />
  );
};
